import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import {
  generateInputField,
  generateSelectField,
} from "helpers/form_helper_new";
import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  createUserInvoice,
  editUserInvoice,
  getDetailUserInvoice,
} from "store/general-info/user/actions";
import * as yup from "yup";
import { modeDetail } from "./utils";

const DetailData = props => {
  const { isOpenModal, dataDetail, toggleModal, mode } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["user"]);
  const { addToast } = useToasts();

  const Dashboard = useSelector(state => state.Dashboard);
  const { listBuOfTenant, listBuChild } = Dashboard;

  const optionsBuParent = useMemo(() => {
    if (listBuOfTenant) {
      return listBuOfTenant
        ?.filter(f => f.value !== "ALL_BU")
        ?.map(b => {
          return {
            value: b.code,
            label: b.code + " - " + b.ten,
            data: {
              id: b.id,
            },
          };
        });
    }
    return [];
  }, [listBuOfTenant]);

  const optionsBuChild = useMemo(() => {
    if (listBuChild) {
      return listBuChild?.map(b => {
        return {
          value: b.code,
          label: b.code + " - " + b.ten,
          data: {
            id: b.id,
            parent_id: b.parent_id,
          },
        };
      });
    }
    return [];
  }, [listBuChild]);

  const userInvoice = useSelector(state => state.userInvoice);
  const { detailUser, createUser } = userInvoice;

  const schema = yup.object().shape({
    code: yup.string(),
    display_name: yup.string(),
    list_bu: yup.array().of(
      yup.object().shape({
        bu_parent: yup
          .object()
          .shape({
            label: yup.string(),
            value: yup.string(),
            data: yup.object().shape({
              id: yup.string(),
            }),
          })
          .nullable(),
        bu_childs: yup.array().of(
          yup.object().shape({
            label: yup.string(),
            value: yup.string(),
            data: yup.object().shape({
              id: yup.string(),
              parent_id: yup.string(),
            }),
          })
        ),
        options_bu_child: yup.array().of(
          yup.object().shape({
            label: yup.string(),
            value: yup.string(),
            data: yup.object().shape({
              id: yup.string(),
              parent_id: yup.string(),
            }),
          })
        ),
      })
    ),
  });

  const dataOriginal = {
    bu_parent: null,
    bu_childs: [],
    options_bu_child: [],
  };

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      code: "",
      display_name: "",
      list_bu: [],
    },
  });

  const {
    fields: fieldBU,
    append: appendBU,
    update: updateBU,
    remove,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "list_bu", // unique name for your Field Array
    keyName: "value", // keyName: "id", default to "id", you can change the key name
  });

  useEffect(() => {
    if (errors) {
      console.log("🚀 ~ useEffect ~ errors:", errors);
    }
  }, [errors]);

  useEffect(() => {
    if (isOpenModal) {
      reset();
      if (dataDetail) {
        dispatch(getDetailUserInvoice(dataDetail?.id));
      }
    }
  }, [isOpenModal]);

  useEffect(() => {
    const { data } = detailUser;
    if (data) {
      const { code, display_name, items } = data;
      setValue("code", code);
      setValue("display_name", display_name);
      if (items?.length > 0) {
        for (const bu of items) {
          const optionBuChild = optionsBuChild?.filter(
            buChild => buChild?.data?.parent_id === bu.id
          );
          const buAppend = {
            bu_parent: {
              label: bu.bu_code + " - " + bu.ten,
              value: bu.bu_code,
              data: {
                id: bu.id,
              },
            },
            bu_childs: [],
            options_bu_child: optionBuChild,
          };
          if (bu?.list_child) {
            for (const child of bu.list_child) {
              buAppend.bu_childs.push({
                label: child.bu_code + " - " + child.ten,
                value: child.bu_code,
                data: {
                  id: child.id,
                  parent_id: child.parent_id,
                },
              });
            }
          }
          appendBU(buAppend);
        }
      } else {
        appendBU(dataOriginal);
      }
    }
  }, [detailUser, optionsBuChild]);

  const onSubmit = values => {
    let listBuCodeUpdate = [];
    const { list_bu } = values;
    if (list_bu?.length > 0) {
      list_bu?.map(bu => {
        const { bu_parent, bu_childs } = bu;
        if (bu_childs?.length > 0) {
          listBuCodeUpdate.push(...bu_childs?.map(c => c.value));
        } else if (bu_parent) {
          listBuCodeUpdate.push(bu_parent?.value);
        }
        return bu;
      });
    }
    const data = {
      ...values,
      user_id: dataDetail?.code,
      listBuCodeUpdate,
    };
    switch (mode) {
      case modeDetail.CREATE:
        dispatch(createUserInvoice(data));
        break;
      case modeDetail.EDIT:
        dispatch(editUserInvoice(data, dataDetail.id));
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>
            {mode === modeDetail.CREATE && `Thêm User`}
            {mode === modeDetail.VIEW && `Chi tiết User`}
            {mode === modeDetail.EDIT && `Cập nhật User`}
          </ModalHeader>
          {detailUser?.loading ? (
            <ModalBody>
              <LoadingFormNormal
                countInput="3"
                countButton="1"
                formClass="row-cols-1 row-cols-md-2"
                buttonClass="justify-content-end"
                buttonColClass="col-3"
              />
            </ModalBody>
          ) : (
            <React.Fragment>
              <ModalBody>
                <Row className="row-cols-1 row-cols-lg-2">
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField({
                        label: t("form.code"),
                        isRequire: true,
                        inputType: "text",
                        errors: errors,
                        touched: touchedFields,
                        fieldName: "code",
                        placeholder: t("placeholder.enter", {
                          title: t("form.code"),
                        }),
                        register: register,
                        disabled: true,
                        control: control,
                        // isThousandSeparator: item.isThousandSeparator,
                        isShowLabel: true,
                        isClassCustomForm: false,
                      })}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField({
                        label: t("form.display_name"),
                        isRequire: true,
                        inputType: "text",
                        errors: errors,
                        touched: touchedFields,
                        fieldName: "display_name",
                        placeholder: t("placeholder.enter", {
                          title: t("form.display_name"),
                        }),
                        register: register,
                        disabled: true,
                        control: control,
                        // isThousandSeparator: item.isThousandSeparator,
                        isShowLabel: true,
                        isClassCustomForm: false,
                      })}
                    </FormGroup>
                  </Col>
                </Row>
                <hr />
                <div className="d-flex justify-content-between">
                  <h5>Quản lý Chi nhánh/Đơn vị :</h5>
                  <Button
                    color="info"
                    className="btn-label"
                    type="button"
                    onClick={() => {
                      appendBU(dataOriginal);
                    }}
                    disabled={detailUser?.loading}
                  >
                    <i className="bx bx-plus label-icon"></i>
                    Thêm chi nhánh
                  </Button>
                </div>
                {fieldBU?.map((bu, index) => {
                  return (
                    <Row key={index}>
                      <Col className="col-4">
                        {generateSelectField({
                          isClearable: true,
                          label: index === 0 ? t("form.bu_parent") : "",
                          isRequire: false,
                          errors: errors,
                          fieldKey: `list_bu.${index}.bu_parent`,
                          placeholder: t("placeholder.select", {
                            title: t("form.bu_parent"),
                          }),
                          disabled:
                            mode === modeDetail.VIEW || detailUser?.loading,
                          control: control,
                          options: optionsBuParent || [],
                          menuPlacementSetting: "auto",
                          onChangeHandle: (buParentChange, fieldKey) => {
                            if (!buParentChange) {
                              updateBU(index, {
                                bu_parent: null,
                                bu_childs: [],
                                options_bu_child: [],
                              });
                              return;
                            }
                            const { id: idBuParentChange } =
                              buParentChange?.data;

                            const listBuParentDup = fieldBU?.filter(
                              bu => bu.bu_parent?.data?.id === idBuParentChange
                            );
                            if (listBuParentDup?.length > 0) {
                              alert(
                                "Chi nhánh đã chọn. Vui lòng chọn chi nhánh khác"
                              );
                              updateBU(index, {
                                bu_parent: null,
                                bu_childs: [],
                                options_bu_child: [],
                              });
                            } else {
                              // Lấy danh sách đơn vị theo chi nhánh
                              updateBU(index, {
                                options_bu_child: optionsBuChild?.filter(
                                  bu => bu?.data?.parent_id === idBuParentChange
                                ),
                                bu_childs: [],
                              });
                            }
                          },
                          isClassCustomForm: false,
                          // isLoading: false,
                          // allowCreate: item.allowCreate,
                          // widthLabel: item.widthLabel,
                          // extraComponent: extraComponent,
                          // isClearable: item.isClearable,
                        })}
                      </Col>
                      <Col className="col-7">
                        {" "}
                        {generateSelectField({
                          isClearable: true,
                          label: index === 0 ? t("form.bu_childs") : "",
                          isRequire: false,
                          errors: errors,
                          fieldKey: `list_bu.${index}.bu_childs`,
                          placeholder: t("placeholder.select", {
                            title: t("form.bu_childs"),
                          }),
                          disabled:
                            mode === modeDetail.VIEW || detailUser?.loading,
                          control: control,
                          options: bu?.options_bu_child || [],
                          menuPlacementSetting: "auto",
                          onChangeHandle: () => {},
                          isClassCustomForm: false,
                          isMulti: true,
                        })}
                      </Col>
                      <Col
                        className="col-1"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <i
                          onClick={() => {
                            remove(index);
                            // const fieldBUAfterRemove = listBUData.filter(
                            //   item =>
                            //     item?.bu_parent?.value !== bu?.bu_parent?.value
                            // );
                            // setValue("list_bu", []);
                            // setTimeout(() => {
                            //   setValue("list_bu", fieldBUAfterRemove);
                            // });
                          }}
                          className="mdi mdi-trash-can  text-danger font-size-18"
                          style={{ cursor: "pointer" }}
                        />
                      </Col>
                    </Row>
                  );
                })}
              </ModalBody>
              <ModalFooter>
                {mode !== modeDetail.VIEW && (
                  <Row className="justify-content-end">
                    <Col className="col-auto">
                      <Button
                        color="primary"
                        className="btn-label"
                        type="button"
                        onClick={() => {
                          handleSubmit(onSubmit)();
                        }}
                        disabled={detailUser?.loading}
                      >
                        <i className="bx bx-save label-icon"></i>
                        {mode === modeDetail.CREATE && t("form.save")}
                        {mode === modeDetail.EDIT && t("form.update")}
                      </Button>
                    </Col>
                  </Row>
                )}
              </ModalFooter>
            </React.Fragment>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

DetailData.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object,
  mode: PropTypes.string,
};

DetailData.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
};

export default DetailData;
